// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"130":"f0c3f280","278":"65c1a145","737":"d64e3be7","756":"09ea1b37"}[chunkId] + ".chunk.css";
};